import { render, staticRenderFns } from "./MonthlyWaterQuality.vue?vue&type=template&id=6d635675&scoped=true"
import script from "./MonthlyWaterQuality.vue?vue&type=script&lang=js"
export * from "./MonthlyWaterQuality.vue?vue&type=script&lang=js"
import style0 from "./MonthlyWaterQuality.vue?vue&type=style&index=0&id=6d635675&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d635675",
  null
  
)

export default component.exports